import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["frame"]

    loadFields(event) {
        const medium = event.target.value
        this.frameTarget.setAttribute("src", `/interaction/touch_points/medium_fields?medium=${medium}`)
    }
}